module.exports = __webpack_public_path__ + "img/smartphones.8da71410.jpg";